import david from "../components/assets/david.jpg";
import annette from "../components/assets/annette.JPG";
import enerico from "../components/assets/enerico.jpeg";
import john from "../components/assets/john.jpg";
import makaka from "../components/assets/makaka.jpg";
import masache from "../components/assets/masache.jpg";
import yambaso from "../components/assets/yambaso.JPG";
import chesteve from "../components/assets/chesteve.jpg";

export const teamData = [
    {
      name: "David Nyirenda",
      post: "CEO & Founder",
      image: david,
    },
    {
      name: "Enerico Chrispin",
      post: "Data Analyst",
      image: enerico,
    },
    {
      name: "Yambaso Kausiwa",
      post: "System Analyst",
      image: yambaso,
    },
    {
      name: "Steven Kamwaza",
      post: "System Developer",
      image: chesteve,
    },
    {
      name: "John Tung'ande",
      post: "Network Engineer",
      image: john,
    },
    {
      name: "Annette Kampango",
      post: "Chief Editor",
      image: annette,
    },
    {
      name: "Solomon Makaka",
      post: "Principal Economist",
      image: makaka,
    },
    {
      name: "Ben Masache",
      post: "Cybersecurity Analyst",
      image: masache,
    },
  ];